import { Alert } from '@creditornot/cb-alert';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Campaign } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import { useCampaignModuleContext } from '../context';
import { CampaignStatus } from '../types';

export const AlertsBanner = ({
  campaignStatus,
  campaign,
}: {
  campaignStatus: CampaignStatus | undefined;
  campaign?: Campaign;
}) => {
  const { entityType, country } = useCampaignModuleContext();

  const bannerKeys = [
    ...(campaignStatus === CampaignStatus.RUNNING && country === 'ISR' ? ['campaigns.edit-end-unavailable'] : []),
    ...(campaign && campaign.venue_ids.length > 1 && entityType !== 'merchant'
      ? ['campaigns.error-multi-venue-campaign']
      : []),
  ];
  const banner =
    bannerKeys.length > 0 ? (
      <Alert variant="warning">
        {bannerKeys.map(key => (
          <div>
            <FormattedMessage key={key} id={key} />
          </div>
        ))}
      </Alert>
    ) : null;
  return banner;
};
